module.exports = __webpack_public_path__ + "bw.222424c28c8317e8fbe0.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/bw.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/bw.svg
// module chunks = styles